export const EMAIL_TEMPLATES = {
  CUSTOM: {
    label: 'Custom',
    subject: '',
    message: '',
  },
  ACIC_CANDIDATE: {
    label: 'ACIC Results Candidate',
    subject: 'ACIC Check Results',
    message: `<p>Dear Candidate,</p>
      <p>Please find attached your <strong>Nationally Coordinated Criminal History Check (NCCHC)</strong> as supplied by the <strong>Australian Criminal Intelligence Commission (ACIC)</strong>.</p>

      <p>As the Accredited Body, <strong>Checkmate Technology Pty Ltd</strong> is required to provide you with the check outcomes before releasing them to your prospective employer. Please read the result document carefully and check for any errors.</p>

      <p><strong>Important - Your Rights</strong></p>
      <ul>
        <li>As the subject of the check, you have a <strong>right to have any errors corrected</strong>. If you wish to dispute the outcome of this check, please reply to this email within <strong>48 hours of receipt</strong>, outlining the reasons that you wish to raise a dispute. One of our team will contact you for more information, and you will be asked to complete a form which we will send to the ACIC and relevant Police services. Your check results will <strong>not be released until the dispute has been resolved</strong>.</li>
        <li>If you choose not to respond, we will release the results as they stand once the <strong>48 hour period has elapsed</strong>.</li>
        <li>If you are <strong>happy with the results</strong>, you do not need to respond — we will release the results to your prospective employer after 48 hours have elapsed. Alternatively, you may provide consent for early release by replying to this email with the words <strong>'No Dispute'</strong>.</li>
        <li>If there are <strong>no disclosable court outcomes</strong> revealed in the check, we can also release the results <strong>immediately</strong> so that your recruitment process can continue.</li>
      </ul>

      <p>Please reply directly to this email if you have any questions or concerns. Your timely response will help ensure a smooth process.</p>

      <p>Thanks,</p>
      <p><strong>The Checkmate Team</strong></p>
      <br/>
      <p><strong>Need Help?</strong></p>
      <p><strong>Email us at <a href="mailto:national-criminal-checks-au@checkmate.tech">national-criminal-checks-au@checkmate.tech</a></strong></p>
      <p><strong>Checkmate – Smart Background Screening made easy</strong></p>`,
  },
};

export const SENDER_EMAILS = {
  ADMIN: process.env.REACT_APP_SUPPORT_EMAIL,
  CHECKS_SUPPORT: process.env.REACT_APP_CHECKS_SUPPORT_EMAIL,
  ACIC_SUPPORT: process.env.REACT_APP_ACIC_SUPPORT_EMAIL,
};

export const EMAIL_TEMPLATE_BOILERPLATES = {
  candidate_request: {
    subject:
      'Hi {{candidateFirstName}}, {{user}} at {{company}} has requested you complete some employment checks',
    body: `<p>Hi {{candidateFirstName}},</p><p>Congratulations on making it to the next phase of the hiring process!</p><p>We partner with Checkmate to streamline our pre-employment screening process.</p><p>This won't take long, and you'll be provided guidance on what's required at the next step.</p><p>To start, please click below:</p>`,
  },
  new_checks_added: {
    subject:
      'Hi {{candidateFirstName}}, {{user}} at {{company}} has requested you complete some additional employment checks',
    body: `<p>Hi {{candidateFirstName}},</p><p>We've added some additional checks to your application that need your attention.</p><p>We partner with Checkmate to manage this step.</p><p>This won't take long, and you'll be provided guidance on what's required at the next step.</p><p>To start, please click below:</p>`,
  },
  new_referee_nomination: {
    subject:
      'Hi {{candidateFirstName}}, {{user}} at {{company}} has requested you to nominate a new referee',
    body: '<p>Hi {{candidateFirstName}},</p><p>{{user}} has requested a new referee for your reference check.</p><p>Follow the link below to complete the request.</p>',
  },
  replace_referee: {
    subject: 'Hi {{candidateFirstName}}, nominate a replacement for {{refereeFullName}}',
    body: '<p>Hi {{candidateFirstName}},</p><p>We hope this email finds you well.</p><p>We request you to nominate a replacement for referee <b>{{refereeFullName}}</b> using Checkmate.</p><p>Follow the link below to complete the request.</p>',
  },
  new_request_to_referee: {
    subject: 'Hi {{refereeFirstName}}, {{candidateFullName}} has nominated you as a referee',
    body: "<p>Hi {{refereeFirstName}},</p><p>{{candidateFullName}} has listed you as a referee as part of their application process.</p><p>We partner with Checkmate to make providing a reference quick and straightforward. Your feedback will give us valuable context about {{candidateFullName}} and how they work as part of a team.</p><p>When you're ready, click the button below to begin:</p>",
  },
  candidate_portal_invitation: {
    subject:
      'Hi {{candidateFirstName}}, you have been invited to access the candidate portal for your employment check',
    body: '<p>Hi {{candidateFirstName}},</p><p>Thank you for submitting your application for background verification with us.</p><p>To keep you informed throughout the process, we’ve created a secure Candidate Portal for you. Through this portal, you can:</p><ul><li>Track the status of your background verification checks</li><li>View and manage your consents</li><li>Download reports once they are available</li></ul><p>Please click the button below to access the portal.</p>',
  },
};

export const EMAIL_TEMPLATE_TYPES = {
  CANDIDATE_REQUEST: 'candidate_request',
  NEW_CHECKS_ADDED: 'new_checks_added',
  NEW_REFEREE_NOMINATION: 'new_referee_nomination',
  REPLACE_REFEREE: 'replace_referee',
  NEW_REQUEST_TO_REFEREE: 'new_request_to_referee',
  CANDIDATE_PORTAL_INVITATION: 'candidate_portal_invitation',
};

export const EMAIL_TEMPLATE_TYPES_VALUE = Object.values(EMAIL_TEMPLATE_TYPES);

export const EMAIL_TEMPLATE_TYPE_OPTIONS = [
  { value: EMAIL_TEMPLATE_TYPES.CANDIDATE_REQUEST, label: 'Candidate Request' },
  { value: EMAIL_TEMPLATE_TYPES.NEW_CHECKS_ADDED, label: 'New Checks Added' },
  { value: EMAIL_TEMPLATE_TYPES.NEW_REFEREE_NOMINATION, label: 'New Referee Nomination' },
  { value: EMAIL_TEMPLATE_TYPES.REPLACE_REFEREE, label: 'Replace Referee' },
  { value: EMAIL_TEMPLATE_TYPES.NEW_REQUEST_TO_REFEREE, label: 'New Request to Referee' },
  { value: EMAIL_TEMPLATE_TYPES.CANDIDATE_PORTAL_INVITATION, label: 'Candidate Portal Invitation' },
];

const EMAIL_TEMPLATE_TYPE_VALUES_BY_AUDIENCE = {
  candidate: new Set([
    EMAIL_TEMPLATE_TYPES.CANDIDATE_REQUEST,
    EMAIL_TEMPLATE_TYPES.NEW_CHECKS_ADDED,
    EMAIL_TEMPLATE_TYPES.NEW_REFEREE_NOMINATION,
    EMAIL_TEMPLATE_TYPES.REPLACE_REFEREE,
    EMAIL_TEMPLATE_TYPES.CANDIDATE_PORTAL_INVITATION,
  ]),
  referee: new Set([EMAIL_TEMPLATE_TYPES.NEW_REQUEST_TO_REFEREE]),
};

export function emailTemplateTypeOptionsForCategory(category) {
  const allowed =
    EMAIL_TEMPLATE_TYPE_VALUES_BY_AUDIENCE[category] ??
    EMAIL_TEMPLATE_TYPE_VALUES_BY_AUDIENCE.candidate;
  return EMAIL_TEMPLATE_TYPE_OPTIONS.filter(o => allowed.has(o.value));
}
